export default __webpack_public_path__ + "static/media/STAR_TINY_BLACK.84d9f679.svg";